import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ConfirmDialogProvider } from './ConfirmDialog';
import './style.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing from index.html');
createRoot(root).render(
  <ConfirmDialogProvider>
    <App />
  </ConfirmDialogProvider>
);
